import { useEffect, useState } from 'react';

import { ProviderId } from '../../entities/provider';
import { fetchIntegrations } from '../api/integration';
import { useStandaloneProjects } from './use-standalone-projects';

// Whether each provider actually has connected/usable data — used to hide a provider's dashboard
// section entirely rather than showing an empty/zeroed one. Jira/Trello: real OAuth connection
// status. Standalone has no connect flow — "connected" just means at least one project exists.
export function useConnectedProviders(): { isConnected: Record<ProviderId, boolean>; isLoading: boolean } {
  const [isJiraConnected, setIsJiraConnected] = useState(false);
  const [isTrelloConnected, setIsTrelloConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { projects: standaloneProjects } = useStandaloneProjects();

  useEffect(() => {
    fetchIntegrations()
      .then((d) => {
        setIsJiraConnected(!!d?.isJiraConnected);
        setIsTrelloConnected(!!d?.isTrelloConnected);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  return {
    isConnected: {
      jira: isJiraConnected,
      trello: isTrelloConnected,
      standalone: standaloneProjects.length > 0,
    },
    isLoading,
  };
}
